// Сообщения и метки состояний. Ошибка объявляется диктору сразу (role="alert").
import type { ReactNode } from "react";
import { Icon, type IconName } from "./icons";
import styles from "./Message.module.css";

type Tone = "error" | "warn" | "ok" | "info" | "accent";

const TONE_ICON: Record<Tone, IconName> = {
  error: "alert",
  warn: "alert",
  ok: "check",
  info: "info",
  accent: "shield",
};

export function Message({
  tone,
  children,
  icon,
}: {
  tone: Tone;
  children: ReactNode;
  icon?: IconName;
}) {
  return (
    <div
      className={[styles.message, styles[tone]].join(" ")}
      role={tone === "error" ? "alert" : "status"}
    >
      <Icon name={icon ?? TONE_ICON[tone]} size={18} />
      <span>{children}</span>
    </div>
  );
}

// accent — идёт работа («Печатается»), action — ход за покупателем («Выбери вариант»).
type TagTone = "ok" | "error" | "warn" | "neutral" | "accent" | "action";

const TAG_CLASS: Record<TagTone, string | undefined> = {
  ok: styles.tagOk,
  error: styles.tagError,
  warn: styles.tagWarn,
  neutral: styles.tagNeutral,
  accent: styles.tagAccent,
  action: styles.tagAction,
};

export function Tag({ tone, children }: { tone: TagTone; children: ReactNode }) {
  return <span className={[styles.tag, TAG_CLASS[tone]].join(" ")}>{children}</span>;
}
